<template>
  <v-dialog 
    v-model="modal"
    width="400px"
    scrollable
  >
    <v-card>
      <v-card-title>{{ $t("Send Study") }}</v-card-title>
      <v-divider></v-divider>

      <v-list two-line subheader class="pb-0">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{ study.patName }}</v-list-item-title>
            <v-list-item-subtitle>{{ study.accessionNo }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-card-text class="pb-0">
        <v-list subheader flat>
          <v-list-item-group v-model="selectedClients" multiple>
            
            <template v-if="isNone">
              <div class="grey--text pt-2">
                {{ $t("No DICOM nodes!") }}
              </div>
            </template>
            <template v-else>
              <template v-for="client in clients">
                <v-list-item :key="client">
                  <template v-slot:default="{ active }">
                    
                    <v-list-item-action>
                      <v-checkbox 
                        :input-value="active"
                        color="primary"
                      ></v-checkbox>
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title>{{ client }}</v-list-item-title>
                    </v-list-item-content>

                  </template>
                </v-list-item>
              </template>
            </template>

          </v-list-item-group>
        </v-list>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="modal = false">{{ $t("close") }}</v-btn>
        <v-btn text color="primary" @click="sendStudy">{{ $t("send") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import EventBus from "../../../event-bus";

export default {
  name: "SendModal",
  props: {
    studyData: Object,
  },
  data: () => ({
    modal: false,
    study: {},
    clients: [],
    selectedClients: [],
  }),
  watch: {
    studyData: function (value) {
      this.study = value.data;
      this.modal = true;
    },
  },
  computed: {
    isNone: function() {
      return this.clients.length===0 ? true : false;
    }
  },
  methods: {
    sendError(error) {
      if (error.response) {
        if (
          error.response.status == 500 &&
          error.response.data.status == "error"
        ) {
          EventBus.$emit("SHOW_ERROR", error.response.data.error);
        } else {
          EventBus.$emit("SHOW_ERROR", error.response.data);
        }
      } else {
        EventBus.$emit("SHOW_ERROR", error);
      }
    },
    sendStudy() {
      this.selectedClients.forEach((selected) => {
        axios({
          url: "/api/v1/dicom/send",
          method: "POST",
          data: {
            owner: this.$store.getters.username,
            patName: this.study.patName,
            accessionNo: this.study.accessionNo,
            clientName: this.clients[selected],
            studyDbId: [this.study.studyDbId],
          },
        })
          .then((response) => {
            if (
              !response.data ||
              !response.data.status ||
              !(response.data.status == "done")
            ) {
              this.sendError(response.data.error);
            } else {
              this.modal = false;
          
              if (typeof response.data.jobId === 'undefined') {
                this.sendError("Invalid jobId value.");
              } else {
                this.$emit("onShowJobs");
              }
            }
          })
          .catch((error) => {
            this.sendError(error);
          });
      });
    },
  },
  created() {
    axios({
      url: "/api/v1/dicom/send/clients",
      method: "GET",
    })
      .then((response) => {
        if (
          !response.data ||
          !response.data.status ||
          !(response.data.status == "done")
        ) {
          this.sendError(response.data.error);
        } else {
          if (typeof response.data.clients === 'undefined') {
            this.sendError("Invalid clients value.");
          } else {
            this.clients = response.data.clients;

            // Select if only one available.
            if (this.clients.length === 1) {
              this.selectedClients = [0];
            }
          }
        }
      })
      .catch((error) => {
        this.sendError(error);
      });
  },
};
</script>

<style scoped>
</style>